import { render, staticRenderFns } from "./universal.vue?vue&type=template&id=6179d0be&scoped=true"
import script from "./universal.vue?vue&type=script&lang=js"
export * from "./universal.vue?vue&type=script&lang=js"
import style0 from "./universal.vue?vue&type=style&index=0&id=6179d0be&prod&scoped=true&lang=scss"
import style1 from "./universal.vue?vue&type=style&index=1&id=6179d0be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179d0be",
  null
  
)

export default component.exports